;(function ($) {
  "use strict"
  $(function () {
    $(document).click(function (e) {
      var $currItem = $(e.target).closest(".header__toggle")
      if ($currItem.length !== 0) {
        $currItem.toggleClass("js-active")
        $(".pan").toggleClass("js-active")
        $(".rack").toggleClass("js-active")
        $(".header").toggleClass("fixed")
        $(".wrapper__main").toggleClass("hide")
        $(".header__logo-mobile").toggleClass("hide")
        try {
          if (!$currItem.hasClass("js-active") && $('[data-entity="section-promo"]').length) {
            $('[data-entity="section-promo"]').slick("refresh")
          }
        } catch (e) {}
      }
    })

    $(document).click(function (e) {
      if ($(e.target).closest(".month-wrap").length) {
        $(e.target).closest(".month-wrap").toggleClass("js-open")

        $(document).find(".month:not(.month_spec)").toggleClass("js-open")
      }
    })
    $(document).click(function (e) {
      let $currItem = $(e.target).closest(".integral__button")
      if ($currItem.length !== 0) {
        $currItem.toggleClass("js-active")
        $(".month:not(.month_spec)").toggleClass("js-open")
      }
    })
  })
})(jQuery)
